import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "./apiRoutes";

interface UseGetTaskListByCategoryProps {
  projectId: string;
  planId: string;
  categoryId: string;
  subCategoryId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getTaskListByCategory = async ({
  projectId,
  planId,
  categoryId,
  subCategoryId
}: any) => {
  return await axiosAuth.get(`${PROJECT_API}/${projectId}/plans/${planId}/tasks/by-category?categoryId=${categoryId}&subCategoryId=${subCategoryId}`);
};

const useGetTaskListByCategory = ({
  projectId,
  planId,
  categoryId,
  subCategoryId, queryParams}: UseGetTaskListByCategoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["category-task", subCategoryId],
    queryFn: () => getTaskListByCategory({projectId, planId, categoryId, subCategoryId}),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!categoryId,
    ...queryParams,
  });
};

export default useGetTaskListByCategory;
